export const deleteRole = (payload: { id: number, mode?: string }) => ({
    type: "@saga/DELETE_ROLE",
    payload
});